import { html } from "lit";
var icon_tradedesk_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero">
      <path d="M9.96 3.5v3.91h3.99V17.6h3.85V3.5z" />
      <path
        d="M7.85 16.7a8.03 8.03 0 0 1 4.18-7.06h-5.7a11.88 11.88 0 0 0 5.78 18.31v-4.17a8.03 8.03 0 0 1-4.26-7.09" />
      <path d="M19.72 5.46v4.18a8.03 8.03 0 0 1-5.76 14.85v3.92a11.88 11.88 0 0 0 5.77-22.96" />
    </g>
  </svg>
`;
export {
  icon_tradedesk_default as default
};
//# sourceMappingURL=icon-tradedesk.js.map
